
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { ComponentDocs, Preview } from "@lighting-beetle/lighter-styleguide";
import { Button, ButtonLayout } from "..";
import Card, { CardContent, CardFooter, CardHeader } from "./index";

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1>{`Card`}</h1>
    <p>{`A card serves as an entry point to more detailed information. Cards may contain rich content, such as photos, text, link, list, tables, you name it.`}</p>
    <h2>{`Example`}</h2>
    <Card mdxType="Card">
  <CardContent mdxType="CardContent">
    <h2>Card</h2>
    <p>Content</p>
  </CardContent>
    </Card>
    <h2>{`Variants`}</h2>
    <h3>{`Basic`}</h3>
    <Preview mdxType="Preview">
  <Card mdxType="Card">
    <CardContent mdxType="CardContent">
      <h2>Card</h2>
      <p>Content</p>
    </CardContent>
  </Card>
    </Preview>
    <h3>{`Card header and footer`}</h3>
    <p>{`Card header holds a title and possibly an action button. Card footer is usually used for additional information or confirm/cancellation buttons.`}</p>
    <Preview mdxType="Preview">
  <Card mdxType="Card">
    <CardHeader title="Title" mdxType="CardHeader" />
    <CardContent mdxType="CardContent">Content</CardContent>
    <CardFooter mdxType="CardFooter">
      <ButtonLayout direction="horizontal" mdxType="ButtonLayout">
        <Button mdxType="Button">Action</Button>
        <Button type="primary" mdxType="Button">CTA</Button>
      </ButtonLayout>
    </CardFooter>
  </Card>
    </Preview>
    <h3>{`Card header actions`}</h3>
    <p>{`To add an action button in card header, a Bar is added to wrap things nicely.`}</p>
    <Preview mdxType="Preview">
  <Card mdxType="Card">
    <CardHeader title="Title" actions={<Button mdxType="Button">Action</Button>} mdxType="CardHeader" />
    <CardContent mdxType="CardContent">Content</CardContent>
  </Card>
    </Preview>
    <h3>{`Multiple content sections`}</h3>
    <Preview mdxType="Preview">
  <Card mdxType="Card">
    <CardContent mdxType="CardContent">
      <h2>Card</h2>
      <p>Content</p>
    </CardContent>
    <CardContent mdxType="CardContent">
      <p>Second content</p>
    </CardContent>
  </Card>
    </Preview>
    <h2>{`Props`}</h2>
    <ComponentDocs title="<Card />" component={Card} mdxType="ComponentDocs" />
    <ComponentDocs title="<CardContent />" component={CardContent} mdxType="ComponentDocs" />
    <ComponentDocs title="<CardHeader />" component={CardHeader} mdxType="ComponentDocs" />
    <ComponentDocs title="<CardFooter />" component={CardFooter} mdxType="ComponentDocs" />
    <h2>{`Accessibility`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`<Card />`}</inlineCode>{` component is purely presentational and does not carry any semantic meaning. The only thing you should care about is the usage of correct heading level in `}<inlineCode parentName="p">{`<CardHeader title="" />`}</inlineCode></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;